import { render, staticRenderFns } from "./IsLoading.vue?vue&type=template&id=b4096518&scoped=true&"
import script from "./IsLoading.vue?vue&type=script&lang=ts&"
export * from "./IsLoading.vue?vue&type=script&lang=ts&"
import style0 from "./IsLoading.vue?vue&type=style&index=0&id=b4096518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4096518",
  null
  
)

export default component.exports